<div>
    <form [formGroup]="locationForm">
        <div class="form-group">
            <label class="edit-label-name">{{'_Location_'| translate}}</label>
            <input type="text" class="form-control" formControlName="location" id="create-auto-complete" (focus)="autocompleteFocus($event)" (blur) = "setInput($event)">
            <span class="helper-text" [innerHTML]="'_ActivityLocationHelp_' | translate"></span>
        </div>
    </form>
</div>
